// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.spinner-btn{height:30px;padding-top:0px !important;padding-bottom:0px !important;vertical-align:middle}button.spinner-btn .spinner-holder{display:flex;align-items:center}button.spinner-btn .spinner-holder .spinner{margin-right:5px}button.spinner-btn .spinner-holder .spinner,button.spinner-btn .spinner-holder .ui-icon,button.spinner-btn .spinner-holder .ui-icon svg{width:20px;height:20px}\n", ""]);
// Exports
module.exports = exports;
